import { UnsubscribePage } from "@/features/hca-public";
import { PublicShellWithDiagnoza } from "@/route-helpers/public-shell-with-diagnoza";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/odhlasit/$token")({
  component: OdhlasitRoute,
});

function OdhlasitRoute() {
  const { token } = Route.useParams();
  return (
    <PublicShellWithDiagnoza>
      <UnsubscribePage token={token} />
    </PublicShellWithDiagnoza>
  );
}
